<template>
  <!-- Search products -->
  <Modal
    :confirmationText="'Add Product'"
    :darker="true"
    :headerTitle="headerTitle"
    :hideButtonsContainer="true"
    :isAboveAll="true"
    :isModalOpen="isModalOpen"
    :showButtonLoader="loading"
    @closeModal="handleEmitCloseModal()"
  >
    <template #content>
      <section id="search-products-container">
        <SearchBar :productQuery="productQuery" @input="handleInputChange" />
        <SearchResults
          :activePageItem="activePageItem"
          :productQuery="productQuery"
          :products="products"
          :loading="loading"
          v-on="{ onSelectedProduct: handleEmitCloseModal }"
        />
      </section>

      <ModalAlert
        v-if="showAlertModal"
        :text="'Error trying to get the products'"
        :title="'Error'"
        :isError="true"
        @closeModal="showAlertModal = false"
      />
    </template>
  </Modal>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import _ from "lodash";

import Modal from "@/components/Utils/Modal.vue";
import ModalAlert from "@/components/Utils/ModalAlert.vue";
import SearchBar from "@/components/Projects/Snapsheets/SearchBar.vue";
import SearchResults from "@/components/Projects/Snapsheets/SearchResults.vue";
export default {
  name: "SearchProductsModal",
  components: { SearchBar, SearchResults, Modal, ModalAlert },

  props: {
    isModalOpen: {
      type: Boolean,
    },
    activePageItem: {
      type: Object,
    },
  },

  data() {
    return {
      productQuery: "",
      products: [],
      loading: false,
      error: false,
      showAlertModal: false,
    };
  },

  computed: {
    ...mapState(["colors", "endpoint"]),
    ...mapState("project", ["typeOfProject"]),
    ...mapState("snapsheet", ["color_1", "isEditModeActive"]),
    headerTitle() {
      return `Add new product to your ${this.typeOfProject}`;
    },
  },

  methods: {
    ...mapActions("snapsheet", ["changeEditMode"]),

    handleInputChange(value) {
      this.productQuery = value;
    },

    fetchProductsByQuery: _.debounce(async function () {
      if (this.productQuery.length >= 3) {
        this.loading = true;

        try {
          const { data } = await axios.get(
            this.endpoint + "api/v2/projects/search",
            {
              params: {
                query: this.productQuery,
                color_1: this.color_1,
              },
            }
          );

          this.products = data;
        } catch (error) {
          this.showAlertModal = true;
          this.error = true;
        } finally {
          this.loading = false;
        }
      } else if (this.productQuery.length == 0) {
        this.products = [];
      }
    }, 500),

    handleEmitCloseModal() {
      this.productQuery = "";
      this.products = [];
      this.loading = false;
      this.error = false;
      this.$emit("closeModal");
    },
  },

  watch: {
    productQuery() {
      this.fetchProductsByQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
  .content {
    padding: 0 !important;
  }
}
#search-products-container {
  align-self: flex-start;
  max-width: 600px;
  width: 100%;
  padding-bottom: 1.5rem;
  overflow-y: visible;
  background: white;
  border-radius: 6px;
  box-shadow: 0px 9px 18px 0px #282a3014;
  .header-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid $grey-light;
    h2 {
      margin: 0;
      text-transform: capitalize;
      font-size: 1.25rem;
    }
    button.close {
      height: 30px;
      width: 30px;
      border: none;
      color: white;
      border-radius: 5px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media screen and (max-width: 576px) {
    padding: 0.5rem;
  }
}
</style>
